/**
 * Company Profile Page
 * Main page for viewing company details with tabbed interface
 */

import React from 'react';
import PageLayout from '@/components/layout/PageLayout';
import { TabList } from '@/components/ui/navigation/TabList';
import { PrimaryButton } from '@/components/ui/buttons/PrimaryButton';
import { useCompanyProfile } from '@/hooks/company/useCompanyProfile';
import { CompanyProfileInfoForm } from '@/components/features/company/CompanyProfileInfoForm';
import { CompanyProfileConfigForm } from '@/components/features/company/CompanyProfileConfigForm';


export const CompanyProfile: React.FC = () => {
  const {
    isLoading,
    error,
    profile,
    activeTab,
    setActiveTab,
    handleCancel,
    handleCopySeedAssistance,
    regionOptions,
    communeOptions,
    holdingCompanyOptions,
    fatherCompanyId,
    logoHook,
    infoForm,
    configForm,
    savingInfo,
    savingConfig,
  } = useCompanyProfile();

  if (error) {
    return (
      <PageLayout>
        <div className="flex flex-col gap-4 p-4" data-testid="company-profile-error">
          <div className="text-red-600 text-sm">{error}</div>
          <div>
            <PrimaryButton variant="outline" onClick={handleCancel}>
              Volver al listado
            </PrimaryButton>
          </div>
        </div>
      </PageLayout>
    );
  }

  const tabs = [
    {
      id: 'info',
      label: 'Información Empresa',
      content: (
        <CompanyProfileInfoForm
          profile={profile}
          regionOptions={regionOptions}
          communeOptions={communeOptions}
          infoForm={infoForm}
          savingInfo={savingInfo}
          onCancel={handleCancel}
        />
      ),
    },
    {
      id: 'config',
      label: 'Configuración',
      content: (
        <CompanyProfileConfigForm
          profile={profile}
          configForm={configForm}
          logoHook={logoHook}
          savingConfig={savingConfig}
          onCancel={handleCancel}
          onCopySeedAssistance={handleCopySeedAssistance}
          holdingCompanyOptions={holdingCompanyOptions}
          fatherCompanyId={fatherCompanyId}
        />
      ),
    },
  ];

  const dynamicTitle = profile?.name || undefined;

  return (
    <PageLayout dynamicTitle={dynamicTitle} isLoading={isLoading}>
      <div data-testid="company-profile-page">
        <TabList
          tabs={tabs}
          defaultActiveTab={activeTab}
          onTabChange={(id) => setActiveTab(id as any)}
        />
      </div>
    </PageLayout>
  );
};

export default CompanyProfile;
